import React from "react";
import { SubTitle } from "@/components/pages/Community";
import { Stack, Unstable_Grid2 as Grid } from "@mui/material";
import styles from "./CommunityBanner.module.scss";

const CommunityBanner = ({ list }) => (
  <Grid container spacing={4.5} sx={{ marginTop: 4, color: "white" }}>
    {list.map(({ title, links }) => (
      <Grid item key={title} xs={12} md={6} lg={4}>
        <SubTitle className={styles.columnTitle}>{title}</SubTitle>
        <Stack sx={{ color: "white" }}>
          {links.map(({ text, url }) => (
            <a key={text} href={url} className={styles.columnLink}>
              {text}
            </a>
          ))}
        </Stack>
      </Grid>
    ))}
  </Grid>
);

export default CommunityBanner;
